<template>
    <div>
        <div id="page">
            <Header @confirm="changeCity"></Header>
        <div class="areaw01">
            <div class="area-sel">
                <span @click="showPop(1)">行政区域</span>
                <div class="sort-pop" v-show="popIndex == 1">
                    <div class="sort-pop-bg" @click="popIndex = 0"></div>
                    <div class="sel-tree">
                        <ul class="list tac">
                            <li v-for="(item, index) in areaList" :class="{'on': activeArea === index}" @click="sortSelected('activeArea', index)">{{ item.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="area-sel">
                <span @click="showPop(2)">开发区</span>
                <div class="sort-pop" v-show="popIndex == 2">
                    <div class="sort-pop-bg" @click="popIndex = 0"></div>
                    <div class="sel-tree">
                        <ul class="list tac">
                            <li v-for="(item, index) in zoneType" :class="{'on': activeZoneType === index}" @click="sortSelected('activeZoneType', index)">{{ item }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="wp">
            <div class="filterw01">
                <div class="clear">清空</div>
                <div class="filterw01-list">
                    <div class="item">产业园</div>
                </div>
            </div>
        </div>-->
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
            <div class="listw01-item" v-for="(item, index) in list">
                <router-link :to="{path: 'developmentDetail', query: {id: item.development_zone_id}}">
                    <div class="listw01-item-pic"><img :src="item.thumbnail" alt=""></div>
                    <div class="listw01-item-txt">
                        <div class="listw01-item-name">{{ item.zone_name }}</div>
                        <div class="listw01-item-info"><div class="lab">项目地址：</div><div class="val">{{ item.address }}</div></div>
                        <div class="listw01-item-info"><div class="lab">邮编：</div><div class="val">{{ item.zip_code }}</div></div>
                        <div class="listw01-item-tags"><span v-for="sub in item.labels">{{ sub.label }}</span></div>
                    </div>
                </router-link>
            </div>
        </van-list>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>


    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { List } from 'vant';

    export default {
        name: "Development",
        data: function(){
            return {
                loading: false,
                finished: false,
                areaList: [],
                activeArea: 0,
                zoneType: {},
                activeZoneType: 0,
                popIndex: 0,
                page: 1,
                list: [],
                downPath: this.api.downPath
            }
        },
        components: {
            Header, Footer,
            [List.name]: List
        },
        mounted(){
            this.getAddr();
            this.getZoneType();
            this.getList();
        },
        methods: {
            getAddr(){
                const _this = this;
                _this.api.getAreas(_this.$store.getters.activeAddr.id).then(function(response){
                    _this.areaList = response.area_list;
                    _this.areaList.unshift({'name': '全部','id': ''})
                })
            },
            getZoneType(){
                const _this = this;
                _this.api.getZoneType().then(function(response){
                    _this.zoneType = response
                })
            },
            getList(){
                const _this = this;
                _this.api.getDevelopmentList({
                    page: _this.page,
                    pageSize: 20,
                    province_id: _this.$store.getters.activeAddr.upid,
                    city_id: _this.$store.getters.activeAddr.id,
                    area_id: _this.areaList.length>0 ? _this.areaList[_this.activeArea].id : '',
                    zone_type: _this.activeZoneType
                }).then(function(response){
                    _this.page++;
                    _this.loading = false;
                    if (response.development_zone_list.length == 0) {
                        _this.finished = true
                    }
                    _this.list = _this.list.concat(response.development_zone_list)
                })
            },
            onLoad(){
                setTimeout(()=>{
                    this.getList();
                }, 500)
            },
            showPop(index){
                if (this.popIndex == index) {
                    this.popIndex = 0;
                } else {
                    this.popIndex = index;
                }
            },
            sortSelected(type, index){
                this[type] = index;
                this.popIndex = 0;
                this.page = 1;
                this.list = [];
                this.getList();
            },
            changeCity(){
                this.page = 1;
                this.list = [];
                this.getList();
            }
        },
    }
</script>

<style scoped>

    .sort-pop {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100vw;
        height: calc(100vh - 1.8rem);
        z-index: 99;
    }
    .sort-pop-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .6);
        z-index: 0;
    }
    .sort-pop .hd {
        position: relative;
        background-color: #f8f8f8;text-align: center;padding: .3rem;
    }
    .sort-pop .label {display: inline-block;position: relative;overflow: hidden;}
    .sort-pop .label input {position: absolute;top: 0;left: 0;width: 0;height: 0;opacity: 0;visibility: hidden;}
    .sort-pop .label span {display: block;width: 1.5rem;height: .5rem;line-height: .5rem;background-color: #fff;color: #989898;font-style: .24rem;}
    .sort-pop .label input:checked + span {color: #ffffff;background-color: #24b5fe;}
    .sort-pop .label:first-child {border-top-left-radius: .1rem;border-bottom-left-radius: .1rem;}
    .sort-pop .label:last-child {border-top-right-radius: .1rem;border-bottom-right-radius: .1rem;}
    .sel-tree {position: relative;height: 50vh;background-color: #fff;overflow: hidden;border-top: 1px solid #aaa;font-size: 0;}
    .sel-tree .left {display: inline-block;vertical-align: top;width: 50%;border-right: 1px solid #aaaaaa;height: 100%;background-color: #f8f8f8;}
    .sel-tree .right {display: inline-block;vertical-align: top;width: 50%;height: 100%;}
    .sel-tree .list {font-size: .24rem;color: #6b6b6b;line-height: .9rem;height: 100%;overflow-y: auto;}
    .sel-tree .list li {padding-left: .5rem;}
    .sel-tree .list li.on {background-color: #fff;color: #24b5fe;}
    .sel-tree .list.tac li {padding: 0;text-align: center}
    /deep/ .van-list {min-height: calc(100vh - 3.64rem);}
</style>